import {ReactNode, useState} from "react";

interface CollapsibleProps {
    title: ReactNode;
    defaultOpen?: boolean;
    // Optional controlled mode. When `open` is provided, the parent owns the
    // state and must respond via onOpenChange. Otherwise the component falls
    // back to internal state driven by defaultOpen.
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    children: ReactNode;
}

function Collapsible({title, defaultOpen = true, open, onOpenChange, children}: CollapsibleProps) {
    const [internalOpen, setInternalOpen] = useState(defaultOpen);
    const isControlled = open !== undefined;
    const effectiveOpen = isControlled ? open : internalOpen;

    function toggle() {
        const next = !effectiveOpen;
        if (isControlled) {
            onOpenChange?.(next);
        } else {
            setInternalOpen(next);
        }
    }

    // Only toggle when the click lands on the header background itself, not
    // when it bubbles up from an interactive child (name input, checkbox,
    // trash button, etc.). The caret has its own handler so clicking it
    // still toggles regardless of where bubbling would have gone.
    function onHeaderClick(e: React.MouseEvent) {
        if (e.target === e.currentTarget) toggle();
    }

    function onCaretClick(e: React.MouseEvent) {
        e.stopPropagation();
        toggle();
    }

    return (
        <div>
            <div className={'layout horizontal gap'} onClick={onHeaderClick}
                 style={{userSelect: 'none', alignItems: 'center'}}>
                <span className={'fa-solid fa-caret-right'}
                      onClick={onCaretClick}
                      style={{
                          transform: effectiveOpen ? 'rotate(90deg)' : 'rotate(0)',
                          transition: '0.2s ease',
                          width: 12,
                          color: 'white',
                          fontSize: 14,
                          cursor: 'pointer',
                      }}/>
                {title}
            </div>
            {effectiveOpen && children}
        </div>
    );
}

export default Collapsible;
